<template>
    <div>

        <h6 :class="titleClass" style="background-color:rgba(200,200,200,0.2);" v-if="title && !isEmpty">
            {{ title }}
        </h6>

        <div class="trax-struct">
            <div :id="id+'-struct'" class="trax-struct-body">
                <div class="trax-block trax-level-1" v-for="(typeName, typeCode) in itemTypes" :key="typeCode" v-if="itemsByType[typeCode]">

                    <button class="btn btn-link btn-just-icon btn-sm float-left trax-help" @click="showGuide($event, typeCode)">
                        <i class="material-icons">help_outline</i>
                    </button>

                    <div class="trax-block-header">
                        
                        <div class="float-right" v-if="!editDisabled">
                            <trax-ui-choice v-model="columnValues[typeCode]" :options="gradeSelect"
                                size="xs" allow-unselect="1"
                                @change="selectColumn($event, typeCode)"
                            ></trax-ui-choice>
                        </div>

                        <h4>{{ typeName }}</h4>
                    </div>

                    <div :id="id+'-struct-'+typeCode" class="trax-block-body">
                        <div :class="itemClass(item)" v-for="item in itemsByType[typeCode]" :key="item.id"  :data-id="item.id">
                            
                            <div class="float-right">
                                <trax-ui-choice v-model="value[item.uuid]" :options="gradeSelect" v-if="!item.title"
                                    size="xs" :disabled="editDisabled" allow-unselect="1"
                                    @change="unselectColumn(typeCode)"
                                ></trax-ui-choice>

                                <p class="text-right" style="margin-top:-8px;margin-bottom:0px !important;padding:0 0.5rem 0 0 !important;color:#ccc !important;" v-if="authors[item.uuid]">
                                    <small>
                                        <i class="material-icons" style="color:#ccc !important;">check</i>
                                        {{ authors[item.uuid].user_name }}
                                    </small>
                                </p>
                            </div>
                            <p>{{ item.name }}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            id: null,
            idAssessmentGuide: null,
            itemTypes: null,
            assessmentType: null,
            assessmentItems: null,
            value: null,
            authors: null,
            editDisabled: null,
            title: null,
            titleTop: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                rating_scale: data.rating_scale,
                grade_select: data.grade_select,
                itemsByType: {},
                columnValues: {},
            }
        },

        created: function() {
            this.setData();
        },

        watch: {
            value: function(newValue) {
                this.bus.$emit('input', newValue);
            }
        },

        computed: {

            gradeSelect() {
                var select = [...this.grade_select];
                select.push({value: 0, name: 'n/o', color: 'default'});
                return select;
            },

            titleClass: function() {
                var res = 'text-center pb-2 pt-2 mb-3 ';
                if (this.titleTop) res += 'mt-2';
                else res += 'mt-4';
                return res;
            },

            isEmpty: function() {
                for (var key in this.itemsByType) {
                    if (this.itemsByType.hasOwnProperty(key)) return false;
                }
                return true;
            }
        },

        methods: {

            selectColumn(value, typeCode) {
                let newValue = {...this.value}
                for (const item of this.itemsByType[typeCode]) {
                    newValue[item.uuid] = value
                }
                this.$emit('input', newValue)
            },

            unselectColumn(typeCode) {
                this.columnValues[typeCode] = null
            },

            itemClass(item) {
                var res = 'trax-block trax-level-2 clearfix';
                if (item.title) res += ' trax-title-bold';
                return res;
            },

            showGuide(event, typeCode) {
                var settings = { assessment_type: this.assessmentType, item_type: typeCode };
                this.bus.$emit(this.idAssessmentGuide+'-load-guide', settings);
                this.bus.$emit(this.idAssessmentGuide+'-open', {title: this.itemTypes[typeCode]});
            },

            setData() {
                this.itemsByType = {};
                for (var index in this.assessmentItems) {
                    var item = this.assessmentItems[index];
                    if (this.itemsByType[item.item_type] == undefined) this.itemsByType[item.item_type] = [];
                    this.itemsByType[item.item_type].push(item);
                }
            }
        }
    }
</script>
